// extracted by mini-css-extract-plugin
module.exports = {"root":"teamList_root__1semP","loadingContainer":"teamList_loadingContainer__vItPV"};